module.exports = __webpack_public_path__ + "assets/img/results_null.154bb023.png";